<template>
    <div>
        <h3>Configuración de códigos de barras</h3>
        <div class="card mb-0">
            <div class="card-body" v-loading="loading_data">
                <div class="row mb-4">
                    <div class="col-12">
                        <h4>Configuración</h4>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="form-group"
                            :class="{ 'has-danger' : errors.name }"
                        >
                            <label class="control-label">
                                Nombre de la plantilla
                            </label>
                            <el-input v-model="form.name"></el-input>
                            <small class="form-control-feedback" v-if="errors.name" v-text="errors.name[0]"></small>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="form-group"
                            :class="{ 'has-danger' : errors.width }"
                        >
                            <label class="control-label">
                                Ancho (mm)
                                <el-tooltip content="Ancho en milimetros"
                                    placement="top">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </label>
                            <el-input-number v-model="form.width"
                                controls-position="right"
                                :min="1"
                            ></el-input-number>
                            <small class="form-control-feedback" v-if="errors.width" v-text="errors.width[0]"></small>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="form-group"
                            :class="{ 'has-danger' : errors.height }"
                        >
                            <label class="control-label">
                                Altura (mm)
                                <el-tooltip content="Altura en milimetros"
                                    placement="top">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </label>
                            <el-input-number v-model="form.height"
                                controls-position="right"
                                :min="1"
                            ></el-input-number>
                            <small class="form-control-feedback" v-if="errors.height" v-text="errors.height[0]"></small>
                        </div>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-12">
                        <h4>
                            {{ showAdvanced ? 'Ocultar' : 'Mostrar' }} Configuración avanzada
                            <i class="ml-4 fa" :class="showAdvanced ? 'fa-angle-up' : 'fa-angle-down'"
                                style="cursor: pointer;"
                                @click="showAdvanced = !showAdvanced"
                            ></i>
                        </h4>
                    </div>
                    <template v-if="showAdvanced">
                        <div class="col-12 col-md-3">
                            <div class="form-group"
                                :class="{ 'has-danger' : errors.nro_columns }"
                            >
                                <label class="control-label">
                                    Número de columnas
                                </label>
                                <el-input v-model="form.nro_columns"></el-input>
                                <small class="form-control-feedback" v-if="errors.nro_columns" v-text="errors.nro_columns[0]"></small>
                            </div>
                        </div>
                        <div class="col-12 col-md-3">
                            <div class="form-group"
                                :class="{ 'has-danger' : errors.spacing_between_columns }"
                            >
                                <label class="control-label">
                                    Espaciado entre columnas (mm)
                                    <el-tooltip content="Espaciado en milimetros"
                                        placement="top">
                                        <i class="fa fa-info-circle"></i>
                                    </el-tooltip>
                                </label>
                                <el-input-number v-model="form.spacing_between_columns"
                                    controls-position="right"
                                    :min="0"
                                >
                                </el-input-number>
                                <small class="form-control-feedback" v-if="errors.spacing_between_columns" v-text="errors.spacing_between_columns[0]"></small>
                            </div>
                        </div>
                        <div class="col-12 col-md-3">
                            <div class="form-group">
                                <label class="control-label">
                                    Ajuste horizontal (mm)
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            Ajuste horizontal para imprimir en milimetros,<br>
                                            disponible cuando el número de columnas es mayor a 1.
                                        </div>
                                        <i class="fa fa-info-circle"></i>
                                    </el-tooltip>
                                </label>
                                <el-input-number v-model="form.offset_x_mm"
                                    controls-position="right"
                                    :min="0"
                                >
                                </el-input-number>
                                <small class="form-control-feedback" v-if="errors.offset_x_mm" v-text="errors.offset_x_mm[0]"></small>
                            </div>
                        </div>
                        <div class="col-12 col-md-3">
                            <div class="form-group">
                                <label class="control-label">
                                    Ajuste vertical (mm)
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            Ajuste vertical para imprimir en milimetros,<br>
                                            disponible cuando el número de columnas es mayor a 1.
                                        </div>
                                        <i class="fa fa-info-circle"></i>
                                    </el-tooltip>
                                </label>
                                <el-input-number v-model="form.offset_y_mm"
                                    controls-position="right"
                                    :min="0"
                                >
                                </el-input-number>
                                <small class="form-control-feedback" v-if="errors.offset_y_mm" v-text="errors.offset_y_mm[0]"></small>
                            </div>
                        </div>
                        <div class="col-12 col-md-3">
                            <div class="form-group"
                                :class="{ 'has-danger' : errors.barcode_type }"
                            >
                                <label class="control-label">
                                    Tipo de código de barras
                                </label>
                                 <el-select v-model="form.barcode_type">
                                    <el-option v-for="(option, index) in barcodes"
                                        :key="index"
                                        :label="option.description"
                                        :value="option.id"
                                    ></el-option>
                                 </el-select>
                                <small class="form-control-feedback" v-if="errors.barcode_type" v-text="errors.barcode_type[0]"></small>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="row mb-4">
                    <div class="col-12">
                        <h4>Columnas</h4>
                    </div>
                    <div class="col-12">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nombre</th>
                                        <th class="text-center">Contenido en Negrita</th>
                                        <th>Fuente del contenido
                                            <el-tooltip content="Cuando no tenga valor el campo, tomará el valor original"
                                                placement="top"
                                            >
                                                <i class="fa fa-info-circle"></i>
                                            </el-tooltip>
                                        </th>
                                        <th>Mostrar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in columns">
                                        <td>{{ ++index }}</td>
                                        <td>{{ item.name }}</td>
                                        <td class="text-center">
                                            <el-checkbox v-model="item.bold_content"></el-checkbox>
                                        </td>
                                        <td>
                                            <el-input v-model="item.font_content"></el-input>
                                        </td>
                                        <td>
                                            <el-switch v-model="item.show"></el-switch>
                                        </td>
                                    </tr>
                                    
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <el-button @click="back">Cancelar</el-button>
                        <el-button type="primary"
                            :loading="loading_submit"
                            @click="submit"
                        >
                            {{ lblButton }}
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BarcodeConfigurationForm',
        props: ['id'],
        data() {
            return {
                loading_data: false,
                resource: 'barcode-configuration',
                form: {},
                errors: {},
                showAdvanced: false,
                columns: [],
                loading_submit: false,
                barcodes: [
                    {
                        id: 'TYPE_CODE_128',
                        description: 'TYPE_CODE_128'
                    },
                    {
                        id: 'TYPE_CODE_93',
                        description: 'TYPE_CODE_93'
                    },
                    {
                        id: 'TYPE_CODE_39',
                        description: 'TYPE_CODE_39'
                    },
                ]
            }
        },
        async created() {
            this.initForm()
            this.initListColumns()
            await this.getData()
        },
        computed: {
            lblButton() {
                return this.id ? 'Actualizar' : 'Guardar'
            }
        },
        methods: {
            initForm() {
                this.errors = {}
                this.form = {
                    name: null,
                    width: 50,
                    height: 25,
                    nro_columns: 1,
                    spacing_between_columns: 0,
                    barcode_type: 'TYPE_CODE_128',
                    columns: [],
                    offset_x_mm: 0,
                    offset_y_mm: 0
                }
            },

            initListColumns() {
                this.columns = [
                    {
                        key: 'name',
                        name: 'Nombre producto',
                        bold_content: false,
                        font_content: null,
                        show: true
                    },
                    {
                        key: 'secondary_name',
                        name: 'Nombre secundario',
                        bold_content: false,
                        font_content: null,
                        show: true
                    },
                    {
                        key: 'model',
                        name: 'Modelo',
                        bold_content: false,
                        font_content: null,
                        show: true
                    },
                    {
                        key: 'price',
                        name: 'Precio',
                        bold_content: false,
                        font_content: null,
                        show: true
                    },
                    {
                        key: 'internal_id',
                        name: 'Código interno',
                        bold_content: false,
                        font_content: null,
                        show: true
                    },
                    {
                        key: 'establishment',
                        name: 'Nombre de Establecimiento',
                        bold_content: false,
                        font_content: null,
                        show: true
                    },
                ]
            },

            back() {
                window.location.href = `/${this.resource}`
            },

            async submit() {
                try {
                    this.loading_submit = true
                    this.form.columns = this.columns
                    const url = this.id ? `/${this.resource}/update/${this.id}` : `/${this.resource}`
                    const { data } = await this.$http.post(`${url}`, this.form)
                    if (data.success) {
                        this.$message({
                            type: 'success',
                            message: data.message
                        })
                        this.initForm()
                        this.initListColumns()
                        setTimeout(() => {
                            window.location.href = `/${this.resource}`
                        }, 1500)
                    } else {
                        this.$message.error(data.message)
                    }
                } catch (error) {
                    if (error.response.status === 422) {
                        this.errors = error.response.data
                    } else {
                        const message = error.response.data.message || "Error al realizar la operación"
                        this.$message.error(message)
                    }
                } finally {
                    this.loading_submit = false
                }
            },

            async getData() {
                try {
                    this.loading_data = true
                    if (this.id) {
                        const { data } = await this.$http.get(`/${this.resource}/get-record/${this.id}`)
                        if (data.success) {
                            const { columns, ...info } = data.data
                            this.form = info
                            this.columns = columns
                        }
                    }
                } catch (error) {
                    
                } finally {
                    this.loading_data = false
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/tenant/barcode_configuration/partials/form.vue